<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100" v-if="false">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>category</md-icon>
          </div>
          <h4 class="title">方案清單</h4>
        </md-card-header>
        <md-card-content>
          <div class="text-right">
            <md-button href="/my" class="md-primary md-dense">
              上一頁
            </md-button>
            <md-button v-if="false" @click="goToAdd" class="md-primary md-dense">
              Add Item
            </md-button>
          </div>
          <md-table
            :value="table"
            :md-sort.sync="sortation.field"
            :md-sort-order.sync="sortation.order"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar v-if="false">
              <md-field>
                <label>Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  v-model="query"
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search ..."
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }" @click="showUsed(item.id)">
              <md-table-cell md-label="組合名稱" md-sort-by="name">{{
                item.package.name
              }}</md-table-cell>

              <md-table-cell md-label="使用期限">{{
                item.expire_at
              }}</md-table-cell>

              <md-table-cell md-label="數量" >{{
                item.item_amount
              }}</md-table-cell>

              <md-table-cell md-label="已領取" >{{
                item.item_used
              }}</md-table-cell>

              <!-- <md-table-cell md-label="Category" md-sort-by="category.name">{{
                item.category.name
              }}</md-table-cell>
              <md-table-cell md-label="Picture">
                <img
                  v-if="item.image"
                  :src="item.image"
                  style="width: 100px; height: auto"
                  alt="avatar"
                />
              </md-table-cell>
              <md-table-cell md-label="Tags" md-sort-by="tags.name">
                <span
                  v-for="(tag, index) in item.tags"
                  :key="'tag' + index"
                  class="badge badge-default"
                  :style="{ backgroundColor: tag.color, margin: '.1rem' }"
                >
                  {{ tag.name }}
                </span>
              </md-table-cell>
              <md-table-cell md-label="Created At" md-sort-by="created_at">{{
                item.created_at
              }}</md-table-cell>
              <md-table-cell md-label="Actions">
                <md-button
                  class="md-icon-button md-raised md-round md-info"
                  @click="goToEdit(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button
                  class="md-icon-button md-raised md-round md-danger"
                  @click="destroy(item.id)"
                  style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell> -->
            </md-table-row>
          </md-table>


          <div v-if="false" class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">
                        {{ item }}
                      </div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions v-if="false" md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          />
        </md-card-actions>
      </md-card>
    </div>

    <div class="md-layout-item md-medium-size-50 md-small-size-50 md-xsmall-size-100 md-size-50">
      <md-card class="md-layout-example">
        <md-card-actions>
          <md-button @click="showAllUsed()" class="md-primary">
            所有領取明細
            </md-button>
        </md-card-actions>
      </md-card>

      <md-card class="md-layout-example" v-for="(item, key) in table" :key="key">
        <md-card-area md-inset>
          <md-card-media md-ratio="16:9">
            <img :src=item.package.image>
          </md-card-media>

          <md-card-header>
            <h2 class="md-title">{{ item.package_name }}</h2>
            <div class="md-subhead">
              <md-icon>shopping_cart</md-icon>
              <span> 組合數量 : {{ item.item_amount }}</span>
            </div>
            <div class="md-subhead">
              <md-icon>back_hand</md-icon>
              <span class="text-warning"> 領取數量 : {{ item.item_used }}</span>
            </div>
            <div class="md-subhead">
              <md-icon>deck</md-icon>
              <span class="text-success"> 剩餘數量 : {{ item.item_last || 0 }}</span>
            </div>
            <div
              v-show="item.refund_status < 9"
              class="md-subhead">
              <md-icon>schedule</md-icon>
              領取期限 : 
              <span class="text-danger"> 
              {{ item.expire_at }}</span>
            </div>
            <div
              v-show="item.refund_status == 9"
              class="md-subhead">
              <md-icon>schedule</md-icon>
              <span class="text-danger"> 退款日期 : {{ item.refund_at }}</span>
            </div>
          </md-card-header>

          <md-card-content>
          </md-card-content>
        </md-card-area>

        <!-- <md-card-content>
          <h3 class="md-subheading">組合數量</h3>
          <md-card-content>
            {{ item.item_amount}}
          </md-card-content>
          <h3 class="md-subheading">已領取</h3>
          <md-card-content>
            {{ item.item_used}}
          </md-card-content>
        </md-card-content> -->

        <md-card-actions>
          <md-button @click="showUsed(item.id)" class="md-primary">
            明細
            </md-button>
        </md-card-actions>
      </md-card>
    </div>

  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/components/Pagination";
import Swal from "sweetalert2";

export default {
  components: {
    // pagination: Pagination,
  },

  data: () => ({
    table: [],
    footerTable: [
      "Name",
      "Category",
      "Picture",
      "Tags",
      "Created At",
      "Actions",
    ],

    query: null,

    sortation: {
      field: "created_at",
      order: "asc",
    },

    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    },

    total: 0,
  }),

  computed: {
    sort() {
      if (this.sortation.order === "desc") {
        return `-${this.sortation.field}`;
      }

      return this.sortation.field;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    sortation: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    getList() {
      let params = {
        include: "category,tags",
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { name: this.query } : {}),
          ...(this.query ? { category: this.query } : {}),
          ...(this.query ? { tags: this.query } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      this.$store.dispatch("my_packages/list", params).then(() => {
        const packages = this.$store.getters["my_packages/list"];
        this.table = packages.packages;
        this.total = this.$store.getters["my_packages/listTotal"];
      });
    },

    async destroy(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed to change data of default items."
        );
        return;
      }
      const confirmation = await Swal.fire({
        title: "Delete this item?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      });

      if (confirmation.value === true) {
        try {
          await this.$store.dispatch("items/destroy", id);
          await this.$store.dispatch(
            "alerts/success",
            "Item deleted successfully."
          );
          await this.getList();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
              "alerts/error",
              e.response.data.errors[0].title
            );
          } else {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong!"
            );
          }
        }
      }
    },

    goToAdd() {
      this.$router.push({ name: "Add Item" });
    },

    goToEdit(id) {
      this.$router.push({ name: "Edit Item", params: { id } });
    },

    showUsed(id) {
      this.$router.push({ name: "My Packages Used", params: { id } });
    },

    showAllUsed() {
      this.$router.push({ name: "Packages Used All" });
    },
    customSort() {
      return false;
    },
  },
};
</script>
